<template>
  <div class="couponBox">
    <!--S 优惠券-->
    <div class="coupon-con" style="padding-bottom: 0.4rem">
      <div
        class="mid"
        :style="{backgroundImage:'url('+(coupon.isover?couponoverbg:couponbg) +')'}"
        @click="showCouponMsg"
      >
        <div class="mid-coupon" :class="coupon.isover?'mid-coupon-over':''">
          <div class="mid-coupon-title">{{ coupon.name }}</div>
          <ul class="mid-coupon-desc">
            <!--S 优惠券规则大于两条-->
            <div v-if="desc.length>1">
              <li v-for="(item,index) in desc" :key="index">{{ item }}
                <div v-show="isMsg && index===1" class="mid-coupon-moredesc">
                  详情<img :src="coupon.isover?'https://static.didapinche.com/pics/g/coupontemplate_arrowgrey.png':'https://static.didapinche.com/pics/g/coupontemplate_arrow.png'">
                </div>
              </li>
            </div>
            <!--E 优惠券规则大于两条-->
            <!--S 优惠券规则只有1条-->
            <div v-if="desc.length===1">
              <li v-for="(item,index) in descOne" :key="index" :class="index===1?'secondLi':''">
                {{ item }}
                <div v-show="isMsg && index===1" class="mid-coupon-moredesc">详情<img :src="coupon.isover?'https://static.didapinche.com/pics/g/coupontemplate_arrowgrey.png':'https://static.didapinche.com/pics/g/coupontemplate_arrow.png'">
                </div>
              </li>
            </div>
            <!--E 优惠券规则只有1条-->
          </ul>
        </div>
        <div class="mid-coupon-value" :class="{active: coupon.value.toString().length > 2}">
          <!--元-->
          <div v-if="!coupon.isover && !coupon.discount"><span>¥</span>{{ coupon.value }}</div>
          <!--折-->
          <div v-if="!coupon.isover && coupon.discount">
            {{ coupon.value.toString().split('.')[0] }}<span
              v-if="coupon.value.toString().indexOf('.') >-1"
              class="mark"
            >.</span>{{ coupon.value.toString().split('.')[1] }}<span>折</span>
          </div>
          <!--过期-->
          <img v-if="coupon.isover" src="https://static.didapinche.com/pics/g/coupontemplate_couponOverIcon.png" alt="">
        </div>
      </div>
      <div v-if="isApp!=='other' && isApp!=='wxh5'" class="getcouponBtn" :class="coupon.isover ? 'over-active': 'normal'" @click="emitgetcoupon">立即领取</div>
    </div>
    <!--E 优惠券-->
    <!--S  过期  -->
    <!--E  过期  -->
    <!--S 第三方手机号领取模块-->
    <div v-if="isApp === 'other'" class="login-content">
      <div v-if="coupon.isover && !zyf" class="getcouponBtn other-over-active" @click="downloadApp">下载嘀嗒出行App查看更多优惠</div>
      <div v-if="!loginstatus && !coupon.isover">
        <!--手机号-->
        <input
          v-model="phone"
          placeholder="输入手机号"
          maxlength="11"
          class="login-number"
          @input="check"
          @focus="check"
          @blur="check"
        >
        <div class="login-code">
          <!--验证码-->
          <input
            v-model="code"
            placeholder="输入验证码"
            maxlength="4"
            class="login-number login-codeinput"
            @input="check"
            @focus="check"
            @blur="check"
          >
          <div class="login-codebtn" :class="canClick?'':'login-codebtn-notactive'" @click="getcode">{{ codebtn }}</div>
        </div>
        <div class="login-rule">
          <img
            :src="ischeckrule? 'https://static.didapinche.com/pics/g/bfd8rq4k5l4public_popup_tick_sel%402x.png':'https://static.didapinche.com/pics/g/certifiction_checkbox.png'"
            alt=""
            @click="checkRuleFn"
          >
          <div v-if="!zyf">我已阅读并同意嘀嗒出行的<span @click="lawRule">《注册协议》、《隐私政策》及《合乘协议》</span></div>
          <div v-if="zyf">我已阅读并同意<span @click="lawRule">《注册协议》、《隐私政策》及《合乘协议》</span></div>
        </div>
        <div class="login-btn" :class="isLogin? '' : 'login-btn-active'" @click="loginActive">立即领取</div>
        <div v-if="loginstatus && !zyf" class="downloadApp" @click="downloadApp">下载嘀嗒出行App，立即使用</div>
      </div>
    </div>
    <!--E 第三方手机号领取模块-->
    <!--S 微信H5领取模块-->
    <div v-if="isApp === 'wxh5'" class="login-content">
      <div v-if="coupon.isover && !zyf" class="getcouponBtn other-over-active" @click="downloadApp">下载嘀嗒出行App查看更多优惠</div>

      <div v-if="(newUser===1 || client === 'my') && !coupon.isover">
        <!--手机号-->
        <input
          v-model="phone"
          placeholder="输入手机号"
          maxlength="11"
          class="login-number"
          @input="check"
          @focus="check"
          @blur="check"
        >
        <div class="login-code">
          <!--验证码-->
          <input
            v-model="code"
            placeholder="输入验证码"
            maxlength="4"
            class="login-number login-codeinput"
            @input="check"
            @focus="check"
            @blur="check"
          >
          <div class="login-codebtn" :class="canClick?'':'login-codebtn-notactive'" @click="getcode">{{ codebtn }}</div>
        </div>
        <div class="login-rule">
          <img
            :src="ischeckrule? 'https://static.didapinche.com/pics/g/bfd8rq4k5l4public_popup_tick_sel%402x.png':'https://static.didapinche.com/pics/g/certifiction_checkbox.png'"
            alt=""
            @click="checkRuleFn"
          >
          <div v-if="!zyf">我已阅读并同意嘀嗒出行的<span @click="lawRule">《注册协议》、《隐私政策》及《合乘协议》</span></div>
          <div v-if="zyf">我已阅读并同意<span @click="lawRule">《注册协议》、《隐私政策》及《合乘协议》</span></div>
        </div>
        <div class="login-btn" :class="isLogin? '' : 'login-btn-active'" @click="loginActive('wxh5')">立即领取</div>
        <div v-if="loginstatus && !zyf" class="downloadApp" @click="downloadApp">下载嘀嗒出行App，立即使用</div>
      </div>
      <template v-if="newUser!==1 && !code && client !== 'my'">
        <div class="login-btn" @click="rightReceive">立即领取</div>
      </template>
    </div>
    <!--E 微信H5领取模块-->
    <!--S 关注公众号模块（纯图）-->
    <div v-if="coupon.wechat_display" class="bottom" @click="toUrl">
      <img :src="coupon.wechat_url" alt="">
    </div>
    <!--E 关注公众号模块（纯图）-->
  </div>
</template>

<script>
  import { sendCode, login } from '../api/api'
  import { getQueryString } from '@common/libs/util.url.js'
  import Env from '@common/libs/util.env.js'
  import { stringify as qs_stringify } from 'qs'
  import { getAppClient } from '@/utils/environment.util'
  const code = getQueryString('code') || ''
  const CID = getQueryString('cid') || getQueryString('user_cid') || getQueryString('userCid') || ''
  const access_token = getQueryString('access_token')

  const notoapp = getQueryString('notoapp') || null // 是否跳转app
  const zyf = getQueryString('zyf') || null // 是否展示下载按钮
  const app_lient = getAppClient() // 获取环境

  var originLink
  if (Env.isEnvOnline) {
    //  线上
    originLink = 'https://' + window.location.host
  } else if (Env.isEnvECS) {
    //  aliyun
    originLink = 'https://' + window.location.host
  } else {
    // 兼容本地故使用了http
    originLink = 'http://' + window.location.host
  }

  export default {
    name: 'CouponBox',
    props: ['isApp', 'loginstatus', 'coupon', 'guideData', 'newUser'],
    data() {
      return {
        client: getAppClient(true),
        desc: [],
        // coupon: {
        //   title: '嘀嗒送你优惠大礼包',
        //   subtitle: '文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案。',
        //   name: '50元顺风券包',
        //   desc: '· 含3张10元顺风车出行券\n· 含3张10元顺风车出行券元顺风车\n·含3张10元顺风车出行券元顺风车',
        //   value: 50
        //   // backgroundUrl: 'https://static.didapinche.com/pics/g/coupontemplate_couponredbg.png',
        //   // backgroundUrl: 'https://static.didapinche.com/pics/g/coupontemplate_coupongreybg.png',
        //
        // },
        couponoverbg: 'https://static.didapinche.com/pics/g/ib8stkyw3uover.png',
        couponbg: 'https://static.didapinche.com/pics/g/c8feqed7suibeforeBg.png',
        // btnTxt: '立即领取',
        isMsg: false,
        timer: null,
        codebtn: '获取验证码',
        isLogin: false,
        canClick: true,
        phone: '',
        code: '',
        ischeckrule: false,
        // tel: '130234324234',
        discount1: 2,
        discount2: 2,
        isonly: false,
        descOne: [],
        zyf: zyf
      }
    },
    methods: {
      /**
       * @description: 静默登录跳转
       * @param {*}
       * @return {*}
       */
      rightReceive() {
        if (!code) {
          // const locationStr = window.location.origin + window.location.pathname + '?goodCid=' + getQueryString('goodCid') + '&PID=' + getQueryString('PID') ;
          const locationStr = window.location.origin + window.location.pathname + window.location.search
          const finalUri = encodeURIComponent(locationStr)
          const redirectUri = '//web.didachuxing.com/H5/Redirector?url=' + finalUri
          // const redirectUri = finalUri;
          window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?${qs_stringify({
            appid: 'wxf18a88f56d23da94',
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: 'snsapi_userinfo',
            state: 'STATE'
          }, { encode: false })}#wechat_redirect`)
        } else {
          this.emitgetcoupon()
        }
      },
      /**
       * @description 跳转url公众号
       */
      toUrl() {
        window.location = this.coupon.wechat_link || 'https://mp.weixin.qq.com/s/WiwYxQpe6PIUtva0Dv7lTw'
      },
      emitgetcoupon() {
        if (code) {
          this.$emit('getcoupon')
          return
        }
        if (!CID || !access_token) {
          const url = originLink + window.location.pathname + location.search
          localStorage.setItem('local_loginStatus', '1')
          // eslint-disable-next-line no-undef
          app_lient.navigateTo({ url: '/pagesWebView/subLogin/subLogin?backUrl=' + btoa(encodeURIComponent((JSON.stringify(url)))) })
          // app_lient.redirectTo({ url: './uniformlogin?backurl=' + encodeURIComponent('/pages/webviewact?url=' + encodeURIComponent(url)) })
        } else {
          this.$emit('getcoupon')
        }
      },
      setCouponMsg() {
        if (this.coupon.desc.length > 1) {
          this.desc.push(this.coupon.desc[0])
          this.desc.push(this.coupon.desc[1])
          /*
          * 大于两条规则显示【详情】
          * 等于两条且小于18字不显示【详情】
          * 等于两条且大于18字，显示13个字剩余省略并显示【详情】
          * */
          if (this.coupon.desc.length === 2) {
            this.isMsg = this.desc[0].length > 13 || this.desc[1].length > 13
            this.desc[0] = this.desc[0].length < 13 ? this.desc[0] : this.desc[0].slice(0, 13) + '...'
            this.desc[1] = this.desc[1].length < 13 ? this.desc[1] : this.desc[1].slice(0, 13) + '...'
          } else {
            this.desc[0] = this.desc[0].length < 13 ? this.desc[0] : this.desc[0].slice(0, 13) + '...'
            this.desc[1] = this.desc[1].length < 13 ? this.desc[1] : this.desc[1].slice(0, 13) + '...'

            this.isMsg = true
          }
        } else {
          /*
          * 一条规则文案较长时时折行显示，超过两行，省略并显示【详情】
          * */
          this.desc = this.coupon.desc
          const temp = this.coupon.desc[0]
          let str1, str2
          if (temp.length > 13) {
            str1 = temp.slice(0, 13)
            str2 = temp.slice(13).length > 13 ? temp.slice(13, 23) + '...' : temp.slice(13)
            this.isMsg = temp.slice(13).length > 13
            this.descOne.push(str1)
            this.descOne.push(str2)
          } else {
            this.descOne.push(temp)
            this.isMsg = false
          }
        }
      },
      showCouponMsg() {
        if (this.isMsg) {
          this.$emit('couponMsgFn')
        }
      },
      // 获取验证码
      getcode() {
        if (this.canClick) {
          if (!this.phone) {
            this.$didafe.toast('请输入手机号')
          } else if (/^1[3-9]\d{9}$/.test(this.phone)) {
            sendCode(this.phone).then(res => {
              if (res.data.code === 0) {
                this.$didafe.toast('验证码已发送')
                let seconds = 60
                this.canClick = false // 禁用获取验证码按钮
                this.codebtn = seconds + 's' + '后重新获取'
                this.timer = setInterval(() => {
                  this.codebtn = (--seconds) + 's' + '后重新获取'
                  if (seconds <= 0) {
                    this.canClick = true // 打开获取验证码按钮
                    this.codebtn = '获取验证码'
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              } else {
                this.$didafe.toast(res.data.message, { wordWrap: 'auto' })
              }
            }).catch(() => {})
          } else {
            this.$didafe.toast('手机号格式错误')
          }
        }
      },
      loginActive(type) {
        const testphone = /^1[3-9]\d{9}$/
        if (this.isLogin) {
          if (this.phone && this.code && testphone.test(this.phone)) {
            login(this.code, this.phone).then(res => {
              if (res.data.code === 0) {
                localStorage.setItem('didacoupontemeplete_cid', res.data.cid)
                localStorage.setItem('didacoupontemeplete_phone', res.data.phone)
                localStorage.setItem('didacoupontemeplete_token', res.data.access_token)
                // 小B是否是新用户 0 不是新的转 1
                localStorage.setItem('newly', res.data.newly)
                this.$root.newly = res.data.newly
                // localStorage.setItem('time', '');
                // this.$root.cid = res.data.cid;
                if (type === 'wxh5') {
                  this.$emit('wxh5LoginSuccess', this.phone)
                } else {
                  this.$emit('loginSuccess')
                }
              } else {
                this.$didafe.toast(res.data.message, { wordWrap: 'auto' })
              }
            }).catch(() => {})
          } else {
            if (!this.phone) {
              this.$didafe.toast('请输入手机号')
            } else if (!testphone.test(this.phone)) {
              this.$didafe.toast('手机号格式错误')
            } else if (!this.code) {
              this.$didafe.toast('请输入验证码')
            } else if (!this.ischeckrule) {
              this.$didafe.toast('请阅读协议并同意授权')
            }
          }
        } else {
          if (this.phone && this.phone.length === 11 && this.code && this.code.length > 3) {
            this.$didafe.toast('注册/登陆前请先阅读并同意相关协议')
          }
        }
      },
      // 协议勾选
      checkRuleFn() {
        this.ischeckrule = !this.ischeckrule
        this.check()
      },
      // 校验登陆表单是否可高亮可点击
      check() {
        if (this.phone && this.phone.length === 11 && this.code && this.code.length > 3 && this.ischeckrule) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      },
      // 下载嘀嗒出行App，立即使用
      downloadApp() {
        if (notoapp) {
          this.$didafe.toast('微信搜索“嘀嗒出行顺风车拼车”小程序，或者应用商店搜索“嘀嗒出行”下载APP', { wordWrap: true })
        } else {
          if (Env.isiPhone && this.guideData.ios_download_link) { // 如果有ios渠道包就直接下载渠道包
            window.location = this.guideData.ios_download_link
          } else if (Env.isAndroid && this.guideData.download_link) {
            window.location = this.guideData.download_link
          } else {
            window.location = 'https://www.didapinche.com/adh5/static/toapp/toapp.html'
          }
        }
      },
      // 查看我的优惠券
      goCoupon() {
        window.location = 'didapinche://coupon'
      },
      lawRule() {
        if (zyf) {
          window.location = 'https://www.didapinche.com/hapis/go/code/Mx2qr'
        } else {
          window.location = 'https://www.didapinche.com/dida/public/lawrules/index.html'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wx-btn {
    margin: 0 auto;
  }
  .mini-btn {
    font-size: 0.32rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    width: 6.10rem;
    height: .80rem;
    line-height: .8rem;
    margin-top: 0.4rem;
    width: 6.10rem;
    height: .80rem;
    opacity: 1;
    background: #ff7d4d;
    border-radius: 0.5rem;
    outline: none;
    border: 0 none;
    display: block;
    font-weight: 500;
    &::after {
      display: none;
    }
  }
  .couponBox {
    padding-top: 0.4rem;
    width: 100%;
    position: relative;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.1rem 0.28rem 0 rgba(0, 0, 0, 0.15);
    border-radius: 0.26rem;
  }

  .Top {
    padding: 0 0.4rem 0.34rem 0.4rem;
    display: flex;
    justify-content: space-between;
  }

  .titleBox {
    /*width: 4.4rem;*/
    padding-top: 0.4rem;
    color: #56320F;
    font-size: 0.4rem;
    font-weight: bold;
  }

  .stitle {
    font-weight: normal;
    font-size: 0.24rem;
    color: #4E556C;
    padding-top: 0.08rem;
  }

  .stitle-break {
    width: 4.4rem;
  }

  .getcouponBtn {
    width: 6.1rem;
    height: 0.8rem;
    background: #EE9D58;
    box-shadow: 0 0.04rem 0.12rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.45rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.32rem;
    color: #FFFFFF;
    font-weight: bold;
  }
  .over-active{
    background-color: #E9EBEF;
    color: #868DA3;
    margin: 0.56rem auto 0 auto;
  }
  .normal{
    margin: 0.6rem auto 0 auto;
  }
  .mid {
    width: 5.14rem;
    height: 2.04rem;
    padding: 0 0.56rem 0 0.4rem;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;
  }

  .mid-coupon {
    height: 2.04rem;
    /*width: 2.92rem;*/
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
    color: #fff;
  }

  .mid-coupon-over {
    color: #B1B0B0;
    .mid-coupon-desc li::before{
      color: #AAAAAA;
    }
  }

  .mid-coupon-title {
    font-size: 0.32rem;
    /*color: #fff;*/
    padding-bottom: 0.12rem;
    font-weight: bold;
  }

  .mid-coupon-desc {
    line-height: 0.32rem;
    white-space: pre-wrap;
    list-style: none;
    li {
      position: relative;
      font-size: 0.24rem;
      padding-bottom: 0.04rem;
      white-space: nowrap;
    }
    li:before {
      content: '·';
      /*width: 0.06rem;*/
      /*height: 0.06rem;*/
      /*background: #4E556C;*/
      /*border-radius: 50%;*/
      display: inline-block;
      /*font-size: 0.5rem;*/
      color: #fff;
      transform: scale(2);
      padding-right: 0.06rem;
    }
  }

  .onlyLi {
    line-height: 0.4rem;
  }

  .secondLi:before {
    opacity: 0;
  }

  .mid-coupon-moredesc {
    font-size: 0.24rem;
    display: inline-flex;
    padding-left: 0.06rem;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    img {
      margin-left: 0.08rem;
      width: 0.08rem;
      padding-left: 0.03rem;
    }
  }

  .mid-coupon-value {
    width: 1.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FB686E;
    font-size: 0.72rem;
    font-weight: 700;
    font-family: "AvenirNext, AvenirNext-DemiBold";
    span {
      font-weight: bold;
      font-size: 0.32rem;
      padding-right: 0.04rem;
    }
    img {
      width: 1.2rem;
      height: 1.2rem;
    }
    .mark {
      width: 0.04rem;
      font-size: 0.76rem;
      font-family: "AvenirNext, AvenirNext-DemiBold";
      display: inline-block;
      transform: translateX(-0.08rem);
      padding: 0 0.04rem;
    }
  }
  .active{
    font-size: 0.46rem;
    span{
      font-size: 0.26rem;
    }
  }

  .bottom {
    img {
      width: 100%;
      height: 1.72rem;
      display: block;
      border-radius: 0 0 0.26rem 0.26rem;
    }
  }

  .login-content {
    padding: 0 0.4rem 0.6rem 0.4rem;
  }

  .login-number {
    width: 5.7rem;
    height: 1rem;
    margin: 0 auto;
    display: block;
    background-color: #F4F5F7 !important;
    margin-bottom: 0.34rem;
    border-radius: 0.26rem;
    color: #292D39;
    font-size: 0.28rem;
    padding-left: 0.4rem;
  }

  input::-webkit-input-placeholder {
    color: #868DA3;
    font-size: 0.28rem;
    font-weight: normal;
  }

  .login-code {
    margin: 0 auto;
    width: 6.1rem;
    height: 1rem;
    border-radius: 0.26rem;
    background: #F4F5F7;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .login-codeinput {
    width: 2.7rem;
    display: inline-block;
    margin-bottom: 0;
    margin: 0;
  }
  // 解决iOS表单input自动填充后背景色变为黄色
  input::-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
    background-color: #F4F5F7;
  }
  .login-codeinput:focus, .login-codeinput:active {
    background-color: #F4F5F7;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #F4F5F7 inset;	/**通过边框阴影遮挡住背景*/
    transition: background-color 5000s ease-in-out 0s;
    background-color: #F4F5F7;
  }

  .login-codebtn {
    color: #23292f;;
    font-size: 0.28rem;
    font-weight: bold;
    border-left: 1px solid #D8DDE7;
    padding: 0 0.4rem;
    text-align: center;
  }

  .login-codebtn-notactive {
    color: #B8C1D3;
    font-weight: normal;
  }

  .login-rule {
    padding: 0.24rem 0 0.36rem 0rem;
    color: #4E556C;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    font-size: 0.24rem;
    color: #4d5663;
    line-height: 0.34rem;
    img {
      height: 0.28rem;
      width: 0.28rem;
      padding-right: 0.2rem;
      padding-bottom: 0.34rem;
    }
    span {
      color: #23292f;;
      font-weight: bold;
    }
  }

  .login-btn {
    width: 6.1rem;
    height: 0.8rem;
    background: rgba(238, 157, 88, 1);
    box-shadow: 0 0.04rem 0.12rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  .login-btn-active {
    background: #E9EBEF;
    font-weight: 400;
    color: #868DA3;
  }
  .other-over-active{
    margin-top: 0.16rem;
  }
  .coupon-phone {
    color: #4E556C;
    font-size: 0.24rem;
    text-align: center;
    padding-bottom: 0.24rem;
    span {
      color: #F3A006;
      font-weight: bold;
    }
  }

  .downloadApp {
    width: 6.1rem;
    height: 0.8rem;
    background: #EE9D58;
    box-shadow: 0 0.04rem 0.12rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
    color: #fff;
    font-size: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
  .checkCoupon{
    margin: 0 auto;
  }
</style>
